import { cn } from "@omni/utils/styles";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import { useDeliveryItemContext } from "../../../context/deliveryItem.context";
import { formatPriceForEcommerce } from "../../../deliveryItem.base";

type Props = {
    className?: string;
};

export const DeliveryCost = ({ className }: Props) => {
    const { t } = useGranite();
    const { option, montageParents } = useDeliveryItemContext();

    if (montageParents.length !== 0) {
        return null;
    }

    return (
        <p
            className={cn(
                "tw:font-bold tw:m-0 tw:text-right tw:whitespace-nowrap",
                className
            )}
        >
            {option.deliveryCost === 0
                ? t(
                      `general.ecommerce.deliveryCost.free.${option.deliveryType}`
                  )
                : formatPriceForEcommerce(option.deliveryCost)}
        </p>
    );
};
